import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../actions/layoutActions";
import { validatieStatussenLoaded } from "../../actions/validatieStatusActions";
import * as ajaxActions from "../../actions/ajaxCounterActions";
import { throwException } from "../../actions/exceptionActions";

import { setAccount } from "../../actions/settingActions";

import DemoForm from "./DemoForm";
import AutoBindComponent from "../common/AutoBindComponent";
import Section from "../common/Section";
import redirector from "../../util/redirector";
import mergeDeep from "../../util/mergeDeep";
import DemoPageHelper from "./DemoPageHelper";
import * as FilesHelperUtil from "../common/FilesHelperUtil";

class DemoPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context, true);

        this.filesHelper = null;
        this.state = {
            originalModel: {
                textInput: 'original hey',
                textArea: 'original how',
                datumInput: '01-01-2018',
                selectInput: 'ABC',
                autoComplete: 'GHI',
                datalist: 'ANDERE',
                numberInput: 0,
                filesComponent: []
            },
            model: {
                textInput: 'new hey',
                textArea: 'new how',
                datumInput: '09-09-2019',
                selectInput: 'DEF',
                autoComplete: 'JKL',
                datalist: 'GHI',
                numberInput: 99,
                filesComponent: []
            },
            errors: null,
            hasUnsavedChanges: false
        };

        this.pageHelper = new DemoPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount(); // better way to handle unsaved changes
        this.pageHelper.init();
    }

    handleOnDropFile = (propertyName, files) => this.pageHelper.change(FilesHelperUtil.onDropFiles(this.state.model[propertyName], propertyName, files));
    handleOnRemoveFile = (propertyName, fileName) => this.pageHelper.change(FilesHelperUtil.onRemoveFile(this.state.model[propertyName], propertyName, fileName));

    // handleOnUploadFiles = (component, files) => this.filesHelper.uploadFiles(component, files);
    // handleOnDeleteFile = (component, file) => this.filesHelper.deleteOneFile(component, file);
    handleOnSave = () => //this.pageHelper.save();
    {
        const originalModel = mergeDeep({}, this.state.originalModel);
        originalModel.filesComponent = mergeDeep({}, this.state.model).filesComponent;
        this.setState({ originalModel: originalModel });
    }
    handleOnChange = (event) => this.pageHelper.change(event);
    handleOnRevertAll = () => this.pageHelper.revertModel();
    handleOnClose = () => this.pageHelper.close();
    isReadyToRender = () => {
        return this.state.model;
        //&& this.state.fileComponents;
    };

    render() {
        if (!this.isReadyToRender())
            return null;

        const { model, originalModel } = this.state;

        return (
            <Section title={"Demo"}>
                <DemoForm
                    originalModel={originalModel}
                    model={model}
                    onChange={this.handleOnChange}
                    onSave={this.handleOnSave}
                    onClose={this.handleOnClose}
                    fileComponents={{}}
                    onDropFiles={this.handleOnDropFile}
                    onRemoveFile={this.handleOnRemoveFile}
                    fileDownloadUrl=""//{this.filesHelper.getFileDownloadUrl()}
                    templateDownloadUrl=""//{this.filesHelper.getTemplateDownloadUrl()}
                    errors={this.state.errors}
                    disabled={false}
                    readonly={false}
                    revertAll={this.handleOnRevertAll}
                    hasUnsavedChanges={this.state.hasUnsavedChanges}
                />
            </Section>);
    }
}

DemoPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {
        //get ref data
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadDemoPageLayout, dispatch),
        validatieStatussenLoaded: bindActionCreators(validatieStatussenLoaded, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch),
        setAccount: bindActionCreators(setAccount, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DemoPage);